import React, { useEffect, useMemo, useRef } from 'react';
import { AD_CLIENT, ensureAdSenseScript } from '../monetization';

const TEST_MODE = String(process.env.REACT_APP_ADSENSE_TEST_MODE || '').toLowerCase() === 'true';

const baseStyle = {
  display: 'block',
  width: '100%',
};

const AdSenseUnit = ({
  slot = '',
  format = 'auto',
  responsive = true,
  style = {},
  className = '',
  wrapperClassName = '',
  label = '',
  width,
  height,
  bootstrapOnly = false,
  enabled = true,
}) => {
  const unitRef = useRef(null);

  useEffect(() => {
    if (!AD_CLIENT) return;
    ensureAdSenseScript();
  }, []);

  useEffect(() => {
    if (!AD_CLIENT || !slot || bootstrapOnly || !enabled || !unitRef.current) return;
    if (unitRef.current.getAttribute('data-adsbygoogle-status')) return;

    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
    } catch (_error) {
      // ignore push errors during local/hot reload
    }
  }, [bootstrapOnly, enabled, slot]);

  const isFixedSize = Number.isFinite(width) && Number.isFinite(height);

  const adProps = useMemo(() => {
    if (!AD_CLIENT || !slot || bootstrapOnly || !enabled) return null;

    const props = {
      className: `adsbygoogle ${className}`.trim(),
      style: {
        ...baseStyle,
        ...(isFixedSize ? { width: `${width}px`, height: `${height}px` } : {}),
        ...style,
      },
      'data-ad-client': AD_CLIENT,
      'data-ad-slot': slot,
    };

    if (!isFixedSize && format) {
      props['data-ad-format'] = format;
      props['data-full-width-responsive'] = responsive ? 'true' : 'false';
    }

    if (TEST_MODE) {
      props['data-adtest'] = 'on';
    }

    return props;
  }, [bootstrapOnly, className, enabled, format, height, isFixedSize, responsive, slot, style, width]);

  if (bootstrapOnly) return null;
  if (!adProps) return null;

  return (
    <div className={`ad-shell ${wrapperClassName}`.trim()}>
      {label ? <div className="ad-label">{label}</div> : null}
      <ins ref={unitRef} {...adProps} />
    </div>
  );
};

export default AdSenseUnit;
